import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.57092 2.5C8.83454 2.5001 9.04846 2.70914 9.04846 2.9668C9.04846 2.9918 9.04822 6.55165 9.04749 6.57617C9.01773 7.52 8.39629 8.30864 7.53967 8.64258V16.5918C7.53949 17.0934 7.12321 17.5 6.60999 17.5C6.09683 17.5 5.68048 17.0934 5.6803 16.5918V8.64453C4.82107 8.31174 4.19742 7.52187 4.1676 6.57617C4.16683 6.55165 4.16663 2.99181 4.16663 2.9668C4.16663 2.70908 4.38049 2.5 4.64417 2.5C4.90779 2.50005 5.1217 2.70911 5.1217 2.9668V5.27637H6.13245V2.9668C6.13245 2.71084 6.34353 2.50283 6.60999 2.5C6.87122 2.50276 7.08264 2.71079 7.08264 2.9668V5.27637H8.09338V2.9668C8.09338 2.70908 8.30725 2.5 8.57092 2.5ZM13.7291 2.5C14.8911 2.50001 15.8334 3.72549 15.8336 5.2373C15.8336 6.30765 15.3615 7.23536 14.6735 7.68555V16.5889C14.6734 17.0921 14.2504 17.5 13.7291 17.5C13.2078 17.5 12.7849 17.0921 12.7848 16.5889V7.68555C12.0967 7.23537 11.6246 6.30766 11.6246 5.2373C11.6248 3.72548 12.5671 2.5 13.7291 2.5Z",
      fill: "#FF5537"
    }, null, -1)
  ]))]))
}
export default { render: render }